import styled, {css} from 'styled-components';
import {getColorFromSlug} from 'utility/colors';
import { screenWidth } from 'utility/screen-width';

const BUTTON_SIZE_DATA = {
    default: {
        height: '50px',
        height_int: 50,
        horizontal_padding: '10px',
        horizontal_padding_int: 20,
        font_size: '20px',
        font_weight: '400',
        icon_margin: '10px',
        icon_font_size: '16px',
    },
    sm: {
        height: '40px',
        height_int: 40,
        horizontal_padding: '10px',
        horizontal_padding_int: 10,
        font_size: '18px',
        font_weight: '400',
        icon_margin: '10px',
        icon_font_size: '16px',
    },
    xs: {
        height: '30px',
        height_int: 24,
        horizontal_padding: '10px',
        horizontal_padding_int: 6,
        font_size: '16px',
        font_weight: '400',
        icon_margin: '6px',
        icon_font_size: '16px',
    },
};

const getButtonSizeStyles = (size) => {
    const data = BUTTON_SIZE_DATA[size] || BUTTON_SIZE_DATA['default'];
    return css`
        height: ${data.height};
        padding: 0 ${data.horizontal_padding};
        font-size: ${data.font_size};
        font-weight: ${data.font_weight};

        > svg {
            font-size: ${data.icon_font_size};
        }
        > svg.icon-left {
            margin-right: ${data.icon_margin};
        }
        > svg.icon-right {
            margin-left: ${data.icon_margin};
        }
    `;
};

const BUTTON_VARIANTS = {
    default: css`
        color: ${getColorFromSlug('david-yellow')};
        background: ${getColorFromSlug('david-black')};
        border: 2px solid ${getColorFromSlug('david-black')};

        &:hover, &:focus {
            background: ${getColorFromSlug('dark-gray')};
            border: 2px solid ${getColorFromSlug('david-black')};
        }
    `,
    yellow: css`
        color: ${getColorFromSlug('david-black')};
        background: ${getColorFromSlug('david-yellow')};
        border: 2px solid ${getColorFromSlug('david-black')};

        &:hover, &:focus {
            background: ${getColorFromSlug('dark-yellow')};
            border: 2px solid ${getColorFromSlug('david-black')};
        }
    `,
    red: css`
        color: ${getColorFromSlug('white')};
        background: ${getColorFromSlug('dark-red')};
        border: 2px solid ${getColorFromSlug('dark-red')};

        &:hover, &:focus {
            background: ${getColorFromSlug('map-red')};
            border: 2px solid ${getColorFromSlug('map-red')};
        }
    `,
    success: css`
        color: ${getColorFromSlug('success-text')};
        background: ${getColorFromSlug('success-btn-bg')};
        border: 1px solid ${getColorFromSlug('success-border')};

        &:hover, &:focus {
            background: ${getColorFromSlug('success-btn-hover')};
            border: 1px solid ${getColorFromSlug('success-border')};
        }
    `,
};

const getButtonVariantStyles = (variant) => {
    return BUTTON_VARIANTS[variant] || BUTTON_VARIANTS['default'];
};

export const StyledButton = styled.button`
    border-radius: 5px;
    font-family: 'Oswald', serif;
    cursor: pointer;
    width: 100%;
    min-width: 125px;
    // max-width: 200px;
    justify-content: center;
    display: flex;
    align-items: center;

    @media ${screenWidth.below.sm} {
        min-width: 125px;
        font-size: 16px;
        flex-shrink: 0;
    }

    ${({ $size }) => getButtonSizeStyles($size)}
    ${({ $variant }) => getButtonVariantStyles($variant)}
`;

/* =========================================================================
    LEGACY WRAPPERS
    Kept for backward compatibility. New code should use
    <Button variant="yellow" /> instead.
========================================================================= */

export const YellowButtonWrapper = styled.div`
    ${StyledButton} {
        ${BUTTON_VARIANTS.yellow}
    }
`;

export const RedButtonWrapper = styled.div`
    ${StyledButton} {
        ${BUTTON_VARIANTS.red}
    }
`;

export const DeleteButtonWrapper = styled.div`
    ${StyledButton} {
        ${BUTTON_VARIANTS.red}
    }
`;

export const SuccessButtonWrapper = styled.div`
    ${StyledButton} {
        ${BUTTON_VARIANTS.success}
        font-size: 18px;

        @media ${screenWidth.below.sm} {
            max-width: 200px;
        }

        @media ${screenWidth.below.xs} {
            margin-top: 12px;
        }
    }
`;

export const SuccessWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
`;

export const SubmitButton = styled(StyledButton)``;